export default [
  {
    path: '/log',
    name: 'log',
    component: r => require(['views/layout/Main'], r),
    redirect: '/log/sn',
    children: [
      {
        path: 'sn',
        name: 'log-sn',
        component: r => require(['views/log/SN'], r)
      },
      {
        path: 'maintain',
        name: 'log-maintain',
        component: r => require(['views/log/maintain'], r)
      },
      {
        path: 'fault',
        name: 'log-fault',
        component: r => require(['views/log/fault'], r)
      }
    ]
  }
]
